import styles from '@/components/book/Ruler.module.css';

interface RulerProps {
  /** One for the overview and one for each section. */
  units: number;
  /** How far in, 0 to 1. */
  p: number;
  /** What the ruler says, for the screen reader (`Section 6 of 11`). */
  label: string;
}

const TICKS_UNTIL = 25;

/** Where a reader is in a document: a track with a tick per section, a fill and a mark. */
export function Ruler({ units, p, label }: RulerProps) {
  const pct = Math.round(Math.min(1, Math.max(0, p)) * 1000) / 10;
  const ticks = units <= TICKS_UNTIL ? Array.from({ length: units - 1 }, (_, i) => ((i + 1) / units) * 100) : [];
  return (
    <div className={styles.ruler} role="img" aria-label={label}>
      <span className={styles.base} />
      {ticks.map((left) => (
        <span key={left} className={styles.tick} style={{ left: `${left}%` }} />
      ))}
      <span className={styles.read} style={{ width: `${pct}%` }} />
      <span className={styles.at} style={{ left: `${pct}%` }} />
    </div>
  );
}
